<template>
  <div class="mContainer">
    <div class="leftBox">
      <div class="foldBox" @click="foldRight">
        <i
          :class="[
            isFold_right ? 'e6-icon-arrow-r_line' : 'e6-icon-arrow-l_line'
          ]"
          :title="isFold_right ? '收起右侧' : '展开右侧'"
        ></i>
      </div>
      <div
        class="map"
        v-show="tableWinType != 'max'"
        :style="{ height: height_map + 'px' }"
      >
        <!-- 定位页面还有定制的地图初始化方法，所以使用定制的mapInitBack_monitor -->
        <e6LogisticsMap
          ref="aLogisMap"
          :mLevel.sync="mLevel"
          :aLevel.sync="aLevel"
          :mEyeShow.sync="mEyeShow"
          :aEyeShow.sync="aEyeShow"
          :isFullScreen.sync="isFullScreen"
          :categoryList.sync="categoryList"
          @init="mapInitBack_monitor"
          @exportExcel_pullRect="exportExcel_pullRect"
          @fullScreen="fullScreen"
        >
          <template v-slot:searchLoVehicles_pullRect>
            <li class="searchLi">
              <!--  -->
              <span @click="drawRectToSearch_lo_pullRect(2, '找已经定位的车')">
                <i class="a_iconfont a_icon-tubiao21"></i>找已经定位的车
              </span>
            </li>
          </template>
        </e6LogisticsMap>
        <!-- 监控模式 -->
        <div class="mapOper" v-show="monitorStatus != 'stop'">
          <i
            :class="['allView', monitorMode != 1 ? 'close' : '']"
            :title="monitorMode != 1 ? '点击显示全部车辆' : '全部车辆'"
            @click="setMonitorMode(1)"
          ></i>
          <div class="fixedMap" v-show="monitorMode != 1">
            {{ monitorMode == 2 ? "固定地图" : singleVehicle.vehicleNo }}
          </div>
        </div>
        <!-- 主动安全 count-->
        <div class="safeBox" v-show="safeEvent.count > 0">
          <p class="title">今日主动安全事件</p>
          <div @click="openSafeList">
            <span>{{ safeEvent.count }}</span>
            <i class="e6-icon-arrow-r_line"></i>
          </div>
        </div>
      </div>
      <!-- <div id="dragMove" class="dragMove"></div>
            <div id="nResize" class="resize">
              <p>拖拽</p>
            </div>-->
      <div class="list">
        <e6-resizer
          :top="height_map"
          @move="resizerMove"
          :min="38"
        ></e6-resizer>
        <div class="top clearfix">
          <div class="fl">
            <e6Tab :tabList="statTabList" @tabChange="statTabChange"></e6Tab>
          </div>
          <div class="fr">
            <i
              class="e6-icon-export_line"
              title="导出"
              @click="exportExcel"
            ></i>
            <i
              v-show="tableWinType != 'min'"
              class="e6-icon-window-min_line"
              title="最小化"
              @click="changeTableStatus('min')"
            ></i>
            <i
              v-show="tableWinType != 'win'"
              class="e6-icon-window-window_line"
              title="窗口化"
              @click="changeTableStatus('win')"
            ></i>
            <i
              v-show="tableWinType != 'max'"
              class="e6-icon-window-max_line"
              title="最大化"
              @click="changeTableStatus('max')"
            ></i>
            <!-- <i
                          :class="[tableWinType=='min'?'e6-icon-window-window_line':'e6-icon-window-min_line']"
                          :title="tableWinType=='min'?'窗口化':'最小化'"
                          @click="changeTableStatus"
                        ></i>
                        <i
                          :class="[tableWinType=='max'?'e6-icon-window-window_line':'e6-icon-window-max_line']"
                          :title="tableWinType=='max'?'窗口化':'最大化'"
                          @click="changeTableStatus"
                        ></i>-->
          </div>
        </div>
        <div
          class="tableBox"
          v-show="tableWinType != 'min'"
          :style="{ height: height_table + 'px' }"
        >
          <el-bigdata-table
            highlight-current-row
            ref="vehicleTable"
            :data="tableDatas"
            :height="height_table"
            :row-height="26"
            stripe
            border
            :row-class-name="rowCssRender"
            empty-text=" "
            style="width: 100%"
            @row-click="rowClick"
            @select="rowSelect"
            @select-all="rowSelect_all"
          >
            <el-table-column
              fixed
              align="center"
              type="selection"
              width="55"
              :v-model="true"
            ></el-table-column>
            <el-table-column
              fixed
              type="index"
              width="55"
              label="序号"
            ></el-table-column>
            <el-table-column
              v-for="(item, index) in showColsList"
              :key="index"
              :fixed="item.fixed ? item.fixed : false"
              :property="item.prop"
              :label="item.label"
              :min-width="item.minWidth"
              :show-overflow-tooltip="true"
              :sortable="item.sortable ? item.sortable : false"
              :formatter="getTrackPlace"
              :align="item.align ? item.align : 'left'"
              header-align="center"
            ></el-table-column>
          </el-bigdata-table>
        </div>
      </div>
      <!-- 时间点查车 -->
      <e6-box
        class="searchLayer"
        ref="timeSearchLayer"
        title="时间点查车"
        @closeFun="closeTimeSearch"
      >
        <div class="searchContent">
          <el-form ref="form" :model="form_timeSearch" label-width="40px">
            <el-form-item label="时间">
              <el-date-picker
                type="datetime"
                placeholder="选择日期"
                v-model="form_timeSearch.time"
                value-format="timestamp"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="车辆">
              <el-select
                v-model="form_timeSearch.vehicleId"
                filterable
                placeholder="请选择车辆"
              >
                <el-option
                  v-for="item in vehicleList_timeSearch"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="searchBottom">
            <el-button type="primary" @click="fetchVehicle_timeSearch"
              >查询
            </el-button>
          </div>
        </div>
      </e6-box>
    </div>
    <div class="rightBox" v-show="isFold_right">
      <div class="top clearfix">
        <dict-select
          v-model="pageTreeType"
          placeholder="请选择"
          :pkey="'trans_type'"
          @change="changeTreeType"
        ></dict-select>
        <div class="fl">
          <el-popover
            placement="top-start"
            trigger="click"
            popper-class="comDropdown"
            v-model="isShow_moreFun"
          >
            <!--<ul>-->
            <!--<li @click="openDirectiveLayer('photo')">发送拍照指令</li>-->
            <!--<li @click="openDirectiveLayer('lcd')">发送LCD短信</li>-->
            <!--<li @click="openDirectiveLayer('call')">点名</li>-->
            <!--&lt;!&ndash; <li @click="openDirective_photo">指令下发</li> &ndash;&gt;-->
            <!--<li @click="openDirectiveLayer('sd')">SD卡照片提取</li>-->
            <!--<li @click="openTimeSearch">时间点查车</li>-->
            <!--</ul>-->
            <!--<i class="e6-icon-menu_line" slot="reference" title="功能列表"></i>-->
          </el-popover>
        </div>
        <!-- <div class="fr">
                  <i class="e6-icon-tips_line" title="小提示"></i>
                </div>-->
      </div>
      <div
        class="treeList"
        v-loading="treeLoading"
        element-loading-text="数据请求中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.6)"
      >
        <e6-tree
          :list.sync="treeList"
          :is-check="true"
          :issingleleaf="true"
          :is-open="false"
          ref="vehicleTree"
          :func="treeLabelClick"
          :chkfunc="chkChange"
        ></e6-tree>
      </div>
      <div class="bottom">
        <el-input
          size="mini"
          class="iconInp"
          placeholder="搜索车辆"
          v-model="searchTxt"
          @keydown.native.enter="treeSearch"
        >
          <i slot="suffix" class="e6-icon-search_line" @click="treeSearch"></i>
        </el-input>
        <div class="operBtn">
          <i
            :class="[
              monitorStatus == 'play'
                ? 'pause e6-icon-pause_line'
                : 'play e6-icon-play_fill1'
            ]"
            @click="startBtnClick"
          ></i>
          <i class="stop e6-icon-delete_line" @click="stopLo"></i>
          <i
            class="setting e6-icon-set-up_line"
            @click="dialogShow_setting = true"
          ></i>
        </div>
      </div>
    </div>
    <!-- 设置弹出层 -->
    <el-dialog
      title="设置"
      :visible.sync="dialogShow_setting"
      width="500px"
      class="settingBox"
    >
      <el-tabs tab-position="left" class="settingTab">
        <el-tab-pane label="显示设置">
          <div class="dBox">
            <p>
              <span>显示车牌</span>
              <el-switch v-model="loSetting.isShow_vehicleName"></el-switch>
            </p>
            <p>
              <span>显示时间</span>
              <el-switch v-model="loSetting.isShow_time"></el-switch>
            </p>
            <p>
              <span>显示速度</span>
              <el-switch v-model="loSetting.isShow_speed"></el-switch>
            </p>
            <p>
              <span>车辆聚合</span>
              <el-switch v-model="loSetting.isShow_cluster"></el-switch>
            </p>
            <!-- <p class="row">
                          <span>车辆图标</span>
                          <span>
                            <el-radio v-model="loSetting.iconType" label="car" class="iconR">
                              <img :src="iconType_car">
                            </el-radio>
                          </span>
                          <span class>
                            <el-radio v-model="loSetting.iconType" label="arrow" class="iconR">
                              <img :src="iconType_arrow">
                            </el-radio>
                          </span>
                        </p>-->
            <p class="row">
              <span>图标大小</span>
              <span>
                <el-radio v-model="loSetting.iconSize" label="1" class="iconR">
                  <img
                    :src="
                      'e6Images/loCars/' + loSetting.iconType + '/run_2.png'
                    "
                  />
                </el-radio>
              </span>
              <span class>
                <el-radio v-model="loSetting.iconSize" label="0" class="iconR">
                  <img
                    :src="
                      'e6Images/loCars/' + loSetting.iconType + '/run_2_s.png'
                    "
                  />
                </el-radio>
              </span>
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="列表设置">
          <div class="dBox clearfix">
            <draggable
              element="ul"
              v-model="loSetting.hideColsList"
              class="dragBox"
              group="colsSetting"
            >
              <li
                v-for="(item, index) in loSetting.hideColsList"
                :key="index"
                class="item"
              >
                {{ item.label }}
              </li>
            </draggable>
            <draggable
              element="ul"
              v-model="loSetting.showColsList"
              class="dragBox"
              group="colsSetting"
              draggable=".item"
            >
              <li
                v-for="(item, index) in loSetting.showColsList"
                :key="index"
                :class="[item.disabled ? '' : 'item']"
              >
                {{ item.label }}
              </li>
            </draggable>
          </div>
        </el-tab-pane>
        <el-tab-pane label="刷新间隔">
          <div class="dBox">
            <el-select v-model="loSetting.refreshInterval" placeholder="请选择">
              <el-option
                v-for="item in loSetting.refreshIntervalList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSetting">取 消</el-button>
        <el-button type="primary" @click="saveSetting">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 指令下发层 -->
    <el-dialog
      :title="title_directive"
      :visible.sync="dialogShow_directive"
      width="600px"
      class="settingBox"
      @closed="closeDirectiveLayer"
    >
      <div class="dialogContent">
        <div class="left">
          <div class="dTree">
            <e6-tree
              :list.sync="treeList"
              :is-check="
                layerType_directive == 'lcd' || layerType_directive == 'call'
              "
              :is-radio="
                layerType_directive == 'photo' || layerType_directive == 'sd'
              "
              :issingleleaf="true"
              :is-open="true"
              ref="directiveTree"
            ></e6-tree>
          </div>
          <div class="dSearch">
            <el-input
              size="mini"
              class="iconInp"
              placeholder="搜索车辆"
              v-model="searchTxt_directive"
              @keydown.native.enter="treeSearch_directive"
            >
              <i
                slot="suffix"
                class="e6-icon-search_line"
                @click="treeSearch_directive"
              ></i>
            </el-input>
          </div>
        </div>
        <div class="right">
          <!-- 拍照 -->
          <div
            class="dContent photoLayer"
            v-show="layerType_directive == 'photo'"
          >
            <el-checkbox-group v-model="checkList_photo">
              <el-checkbox :label="1">摄像头1</el-checkbox>
              <el-checkbox :label="2">摄像头2</el-checkbox>
              <el-checkbox :label="4">摄像头3</el-checkbox>
              <el-checkbox :label="8">摄像头4</el-checkbox>
            </el-checkbox-group>
            <div class="btnBox">
              <el-button type="primary" @click="sendDirective_photo"
                >发送
              </el-button>
            </div>
          </div>
          <!-- LCD短信 -->
          <div class="dContent lcdLayer" v-show="layerType_directive == 'lcd'">
            <div class="tTop clearfix">
              <span class="title">填写短信内容</span>
              <a
                :class="[info_lcd.isShow_msg ? 'open' : '']"
                @click="openMsgList_lcd"
                >使用固定短信</a
              >
            </div>
            <div class="msgList" v-show="info_lcd.isShow_msg">
              <div class="addBox">
                <span
                  class="addBtn"
                  v-show="!info_lcd.isShow_new"
                  @click="openNewMsg_lcd"
                >
                  <i class="e6-icon-add_line"></i>添加新的固定短信
                </span>
                <div class="addLayer" v-show="info_lcd.isShow_new">
                  <el-input
                    size="mini"
                    placeholder="请输入短信内容"
                    v-model="info_lcd.newMsg"
                  ></el-input>
                  <i class="e6-icon-check_line" @click="saveNewMsg_lcd"></i>
                  <i class="e6-icon-delete_line" @click="closeNewMsg_lcd"></i>
                </div>
              </div>
              <ul>
                <li
                  v-for="(item, index) in msgList_lcd"
                  :key="index"
                  @click.stop="selectOneMsg_lcd(item.message)"
                >
                  {{ item.message }}
                  <i
                    class="e6-icon-delete_line"
                    @click.stop="deleteMsg_lcd(item.id)"
                  ></i>
                </li>
              </ul>
            </div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 3 }"
              placeholder="英文的单引号、双引号、<、>将被替换成空格"
              v-model="info_lcd.message"
            ></el-input>
            <p class="tTips">
              {{ info_lcd.restNum >= 0 ? "还能输入" : "已超出" }}
              <span :class="[info_lcd.restNum < 0 ? 'red' : '']">{{
                info_lcd.restNum > 0
                  ? info_lcd.restNum
                  : Math.abs(info_lcd.restNum)
              }}</span
              >字
            </p>
            <el-checkbox v-model="info_lcd.isCheck_save"
              >发送的同时保存为固定短信
            </el-checkbox>
            <div class="btnBox">
              <el-button type="primary" @click="sendDirective_lcd"
                >发送
              </el-button>
            </div>
          </div>
          <!-- 点名 -->
          <div class="dContent" v-show="layerType_directive == 'call'">
            <div class="btnBox">
              <el-button type="primary" @click="sendDirective_call"
                >点名
              </el-button>
            </div>
          </div>
          <!-- SD卡提取 -->
          <div class="dContent sdLayer" v-show="layerType_directive == 'sd'">
            <el-form ref="form" :model="form_sd" label-width="80px">
              <el-form-item label="开始时间">
                <el-date-picker
                  type="datetime"
                  placeholder="选择日期"
                  v-model="form_sd.startTime"
                  value-format="timestamp"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="时间间隔">
                <el-input-number
                  size="mini"
                  :min="1"
                  v-model="form_sd.interval"
                ></el-input-number>
                <span class="intervalSpan">秒</span>
              </el-form-item>
              <el-form-item label="拍照总数">
                <el-select
                  v-model="form_sd.totalNum"
                  placeholder="请选择活动区域"
                >
                  <el-option label="2张" :value="2"></el-option>
                  <el-option label="5张" :value="5"></el-option>
                  <el-option label="10张" :value="10"></el-option>
                  <el-option label="20张" :value="20"></el-option>
                  <el-option label="30张" :value="30"></el-option>
                  <el-option label="40张" :value="40"></el-option>
                  <el-option label="50张" :value="50"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="拍照方式">
                <el-checkbox-group v-model="form_sd.checkList">
                  <el-checkbox :label="1">1路</el-checkbox>
                  <el-checkbox :label="2">2路</el-checkbox>
                  <el-checkbox :label="4">3路</el-checkbox>
                  <el-checkbox :label="8">4路</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
            <div class="btnBox">
              <el-button type="primary" @click="sendDirective_sd"
                >提取
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 拉框查找 -->
    <e6-box
      class="commonLayer"
      ref="pullRectLayer"
      :title="'拉框查找 - ' + pullRect.title"
      @closeFun="closeListLayer_lo_pullRect"
    >
      <div class="comContent">
        <p class="topStat">
          区域内的车辆数：{{ pullRect.datas.length }} 辆
          <el-button type="primary" size="mini" @click="exportExcel_lo_pullRect"
            >导出Excel
          </el-button>
        </p>
        <el-table
          :data="pullRect.datas"
          max-height="200"
          :fit="true"
          @row-click="rowClick_lo_pullRect"
        >
          <el-table-column
            label="序号"
            type="index"
            width="55"
            header-align="center"
          ></el-table-column>

          <el-table-column
            v-for="(item, index) in tableCols_pullRect"
            :key="index"
            :property="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :show-overflow-tooltip="true"
            :align="item.align ? item.align : 'left'"
            header-align="center"
          ></el-table-column>
        </el-table>
      </div>
    </e6-box>
    <!-- 主动安全 list -->
    <e6-box class="commonLayer" ref="safeList" title="今日主动安全事件列表">
      <div class="comContent">
        <el-table :data="safeEvent.list" max-height="200" :fit="true">
          <el-table-column
            fixed
            type="index"
            width="55"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            fixed
            align="center"
            width="80"
            class-name="operCol"
            label="操作"
          >
            <template v-slot="scope">
              <i
                class="a_iconfont a_icon-chuli"
                title="处理"
                @click.stop="openHandleLayer_safeEvent(scope.row)"
              ></i>
              <i
                class="a_iconfont a_icon-hulve2"
                title="忽略"
                @click.stop="ignore_safeEvent(scope.row)"
              ></i>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in tableCols_safeEvent"
            :key="index"
            :property="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :show-overflow-tooltip="true"
            :align="item.align ? item.align : 'left'"
            header-align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="item.prop == 'eventLevel'"
                :class="['dangerLevel', 'level-' + scope.row[item.prop]]"
                >{{ safeEvent.level[scope.row[item.prop]] }}</span
              >
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </e6-box>
    <!-- 报警处理 -->
    <safe-alarm-handler
      :detailData="safeEvent.detailData"
      :dialogShow="safeEvent.dialogShow"
      @close="closeHandleLayer_safeEvent"
      @handle="handle_safeEvent"
    ></safe-alarm-handler>
  </div>
</template>

<script>
import "@/assets/css/map/e6_common.scss";
import "@/assets/css/map/monitor.scss";
import moment from "moment";
import monitorJson from "../vehicle/monitor.json";
// import { addInfoWinOper } from "@/utils/map/mapToolsFun.js";
import e6LogisticsMap from "@/components/e6LogisticsMap";
import e6Tab from "@/components/e6Tab";
import e6Tree from "e6-tree";
import e6Box from "@/components/e6Box";
import draggable from "vuedraggable";
import e6Resizer from "@/components/resizer";
import request from "@/api/monitorCenter/monitor.js";
import aRequest from "_private/api/alarmAndMsg.js";
import api from "@/api/monitorCenter/track.js";
import elBigdataTable from "@/components/vue-element-bigdata-table";
import safeAlarmHandler from "@/components/safeAlarmHandler/src/safeAlarmHandler";
import { mixin } from "@/mixins/logisOverlaysHandle.js";

export default {
  name: "List",
  mixins: [mixin],
  components: {
    e6LogisticsMap,
    e6Tab,
    e6Tree,
    draggable,
    elBigdataTable,
    e6Resizer,
    e6Box,
    safeAlarmHandler
  },
  data() {
    return {
      HEIGHT_WIN_TABLE: 200, //窗口化的高度
      MAX_TRACK_LINE: 10,
      REFRESH_NUM_SAFEEVENT: 60 * 1000, // 主动安全事件 refresh
      STAT_TAB_LIST: [
        {
          type: "全部",
          color: monitorJson.aColor["all"],
          isActive: true,
          selected: { name: "全部", num: 0, classify: "all" }
        },
        {
          type: "运行",
          color: monitorJson.aColor["run"],
          isActive: false,
          selected: { name: "全部", num: 0, classify: "run" }
        },
        {
          type: "停车",
          color: monitorJson.aColor["stop"],
          isActive: false,
          selected: { name: "全部", num: 0, classify: "stop" }
        },
        {
          type: "报警",
          color: monitorJson.aColor["alarm"],
          isActive: false,
          selected: { name: "全部", num: 0, classify: "alarm" }
        }
        // 20190918 修改，新系统不需要显示异常
        // {
        //   type: "异常",
        //   color: monitorJson.aColor["abnormal"],
        //   isActive: false,
        //   selected: { name: "全部", num: 0, classify: "abnormal" }
        // }
      ],
      selectOpts: null,
      height_map: 0,
      height_table: 0,
      mapName: "aLogisMap",
      searchTxt: "",
      monitorStatus: "stop", //监控状态：paly，pause，stop
      tableWinType: "min", // 'min', 'win', 'max'
      isFold_right: true, //右侧是否展开
      statTabList: [],
      pageTreeType: "",
      treeList: [],
      treeLoading: false,
      // 设置面板相关
      dialogShow_setting: false,
      loSetting: {
        isShow_vehicleName: true,
        isShow_time: false,
        isShow_speed: false,
        isShow_cluster: false,
        iconType: "car", //car - 车辆；arrow - 箭头
        iconSize: "1", //1 - 大图标；0 - 小图标
        hideColsList: [], //隐藏列
        showColsList: [], //显示列
        refreshInterval: 10,
        refreshIntervalList: [
          { value: 10, label: "10秒" },
          { value: 20, label: "20秒" },
          { value: 30, label: "30秒" },
          { value: 40, label: "40秒" },
          { value: 50, label: "50秒" },
          { value: 60, label: "60秒" }
        ]
      },
      // 设置中，会实时改变页面显示状态的多冗余一份数据
      lastTime: 0, //差量数据更新的时间戳
      monitorMode: 1, //监控模式：1-全部车辆；2-固定地图；3-单车监控
      singleVehicle: {
        //单车监控数据
        vehicleId: -1,
        vehicleNo: ""
      }, //单车监控模式的车辆id
      isTriggerMove: false, //是否触发地图移动事件（此变量用于地图移动时判断，因为平移或者设置中心点都会触发地图move函数）
      firstLo: true,
      loIdsArr: [], //当前定位id车辆id数组
      loTimer: null, //定位刷新的时间句柄
      allMarkers: [], //所有markers
      markers: [], //地图上的markers（普通marker，则此数组也是加到地图上的marker；如果是聚合，此数组则仅仅只是需要聚合的marker数组而已，cluster才是真正被加载到地图上的）
      cluster: null, //地图上的聚合点对象
      allLoDatas: [], //所有定位数据
      tableDatas: [],
      selectedRow: [],
      // 设置结果
      isShow_vehicleName: true,
      isShow_time: false,
      isShow_speed: false,
      isShow_cluster: false,
      iconType: "car", //car - 车辆；arrow - 箭头
      iconSize: "1", //1 - 大图标；0 - 小图标
      hideColsList: [], //隐藏列
      showColsList: [], //显示列
      refreshInterval: 10,
      isShow_moreFun: false, // 功能列表
      dialogShow_directive: false,
      title_directive: "",
      titleObj_directive: {
        photo: "发送拍照指令",
        lcd: "发送LCD短信",
        call: "点名",
        sd: "SD卡照片提取"
      },
      treeList_directive: [],
      searchTxt_directive: "",
      layerType_directive: "photo", // photo, lcd, call, sd
      checkList_photo: [],
      form_sd: {
        startTime: moment(new Date()).valueOf(),
        interval: 10,
        totalNum: 10,
        checkList: []
      },
      info_lcd: {
        isShow_msg: false,
        isShow_new: false,
        newMsg: "",
        message: "",
        isCheck_save: false,
        maxlength: 100,
        restNum: 0
      },
      msgList_lcd: [],
      form_timeSearch: {
        time: moment(new Date()).valueOf(),
        vehicleId: ""
      },
      vehicleList_timeSearch: [],
      marker_timeSearch: null,
      // 拉框查询
      pullRect: {
        title: "",
        maxMin: {},
        marker: null,
        rect: null,
        datas: []
      },
      // 主动安全
      safeEvent: {
        timer: null,
        dialogShow: false,
        count: 0,
        detailData: {},
        list: [],
        level: {
          "1": "低",
          "2": "中",
          "4": "高"
        }
      },
      settingcenter: true, //第一次请求设置中心点，后面不再设置
      companyId: "",
      categoryList: []
    };
  },
  computed: {
    tableCols_pullRect() {
      return monitorJson.tableCols_pullRect;
    },
    tableCols_safeEvent() {
      return monitorJson.tableCols_safeEvent;
    }
  },
  // computed: {
  //   // iconSize_big: function() {
  //   //   return `e6Images/loCars/${this.loSetting.iconType}/run_2.png`;
  //   // },
  //   // iconSize_small: function() {
  //   //   return `e6Images/loCars/${this.loSetting.iconType}/run_2_s.png`;
  //   // }
  //   // ,iconType_car: function() {
  //   //   return `e6Images/loCars/car/run_2${this.loSetting.iconSize == 1?'':'_s'}.png`;
  //   // },
  //   // iconType_arrow: function() {
  //   //   return `e6Images/loCars/arrow/run_2${this.loSetting.iconSize == 1?'':'_s'}.png`;
  //   // }
  // },
  watch: {
    height_table: function() {
      this.pageResize();
    },
    "info_lcd.message"() {
      this.info_lcd.restNum =
        this.info_lcd.maxlength - this.info_lcd.message.length;
    },
    isFullScreen: function() {
      this.isFold_right = !this.isFold_right;
      this.pageResize();
    }
  },
  destroyed: function() {
    this.clearLoTimer();
  },
  methods: {
    pageResize() {
      this.height_map =
        document.querySelector(".mContainer").clientHeight -
        document.querySelector(".resizer-drag").clientHeight -
        document.querySelector(".top").clientHeight -
        this.height_table;
      this.$nextTick(() => {
        this.$refs.aLogisMap && this.$refs.aLogisMap.resize();
      });
    },
    //表格tab切换事件
    statTabChange(opts) {
      this.selectOpts = JSON.parse(JSON.stringify(opts));
      this.statTabList.forEach(item => {
        if (item.type == opts.type) {
          item.isActive = true;
          item.selected = JSON.parse(JSON.stringify(opts.selected));
        } else {
          item.isActive = false;
        }
      });
      // 窗口化
      if (this.tableWinType == "min") {
        this.changeTableStatus("win");
      }
      //过滤数据
      this.filterByTab();
    },
    //过滤数据
    filterByTab() {
      this.removeMarkersFromMap();
      this.markers = this.allMarkers.filter(item => {
        let extData = this.$refs.aLogisMap.mapAPI.getExtData(item); //获取自定义属性(item的id与其他数据)
        return this.isInTabFilter(extData.vData);
      });
      // 将markers的数据添加到地图上
      this.addMarkersToMap();
      // 处理表格
      this.dealTable();
    },
    addMarkersToMap() {
      if (this.isShow_cluster) {
        // 聚合
        this.cluster = this.$refs.aLogisMap.mapAPI.createClusterer(
          this.markers
        );
        this.$refs.aLogisMap.mapAPI.addOverlay(this.cluster);
      } else {
        // 普通marker
        this.markers.forEach(item => {
          this.$refs.aLogisMap.mapAPI.addOverlay(item);
          if (item.trackLine) {
            this.$refs.aLogisMap.mapAPI.addOverlay(item.trackLine);
          }
        });
      }
    },
    removeMarkersFromMap(aDelIDs) {
      if (this.isShow_cluster) {
        // 聚合
        this.$refs.aLogisMap.mapAPI.removeOverlay(this.cluster);
      } else {
        // 普通marker
        if (aDelIDs) {
          // 删除某些id的markers，则走另一条分支
          this.deleteMarkers(this.markers, aDelIDs);
        } else {
          this.markers.forEach(item => {
            if (item.trackLine) {
              this.$refs.aLogisMap.mapAPI.removeOverlay(item.trackLine);
            }
            this.$refs.aLogisMap.mapAPI.removeOverlay(item);
          });
        }
      }
      if (!aDelIDs) {
        this.markers = [];
      }
      this.cluster = null;
    },
    //单车监控
    setSingleOpenWin(opts) {
      if (this.monitorStatus != "stop") {
        this.isTriggerMove = false; //是否触发地图移动事件
        this.openInfoWin(opts.vehicleId); //打开信息窗口
        this.setMonitorMode(3, { ...opts }); // 设置监控模式（1-全部车辆；2-固定地图；3-单车监控）
      }
    },
    // 切換树的类型
    changeTreeType(val) {
      this.stopLo();
      if (val == "") {
        val = -1;
      }
      this.fetchVehicleTree(val);
    },
    //树节点点击事件
    treeLabelClick(node) {
      this.setSingleOpenWin({ vehicleId: node.id, vehicleNo: node.label });
    },
    //树节点勾选状态变化时触发的事件
    chkChange(node, isCheck) {
      let loIdsArr_pre = [...this.loIdsArr];
      let opts = this.$refs.vehicleTree.getAllNodes(true, false); //获取所有勾选的节点（叶子节点与非叶子节点）
      this.loIdsArr = opts.ids;
      this.settingcenter = true; //选择树的项后，settingcenter为true，开启中心点的定位
      if (isCheck) {
        // 选中
        if (node.disabled) {
          // 枝节点
          //监控状态为非暂停状态（stop Or play），则监控
          if (this.monitorStatus != "pause") {
            if (this.monitorStatus == "stop") {
              this.monitorStatus = "play";
              this.firstLo = true;
            }
            this.requestLo();
          }
        } else {
          // 叶子节点
          if (this.monitorStatus == "play") {
            this.requestLo_restart();
          }
        }
      } else {
        //取消
        if (this.monitorStatus == "play") {
          // 如果正在进行定位，则处理，否则不进行任何处理
          if (this.loIdsArr.length == 0) {
            this.stopLo();
          } else {
            let cancelIdsArr = loIdsArr_pre.filter(item => {
              return !this.loIdsArr.includes(item.toString());
            });
            //取消的节点中有单车跟踪的车，则进行处理
            if (
              this.monitorMode == 3 &&
              this.singleVehicle.vehicleId != -1 &&
              cancelIdsArr.includes(this.singleVehicle.vehicleId.toString())
            ) {
              this.singleVehicle = { vehicleId: -1, vehicleNo: "" };
              this.monitorMode = 1;
            }
            //取消后重新定位
            this.cancelLoByIds(cancelIdsArr);
          }
        }
      }
    },
    //取消定位
    cancelLoByIds(cIdsArr) {
      // 处理在requestLo后，受前结果影响的数据
      this.deleteMarkers(this.markers, cIdsArr);
      this.deleteMarkers(this.allMarkers, cIdsArr);
      for (let i = this.allLoDatas.length - 1; i >= 0; i--) {
        let loData = this.allLoDatas[i];
        if (cIdsArr.includes(loData.vehicleId.toString())) {
          this.allLoDatas.splice(i, 1);
        }
      }
      // //表格，statNum，和监控模式，重新请求后都会计算，计算不受前结果影响，所以无需处理。
      this.requestLo_restart();
    },
    //重新请求全量数据
    requestLo_restart() {
      // this.firstLo = true;
      this.lastTime = 0;
      this.clearLoTimer();
      this.requestLo();
    },
    // 删除marker，不包括聚合
    deleteMarkers(aMarkers, aDelIDs) {
      for (let i = aMarkers.length - 1; i >= 0; i--) {
        let extData = this.$refs.aLogisMap.mapAPI.getExtData(aMarkers[i]);
        if (aDelIDs.includes(extData.id)) {
          if (aMarkers[i].trackLine) {
            this.$refs.aLogisMap.mapAPI.removeOverlay(aMarkers[i].trackLine);
          }
          this.$refs.aLogisMap.mapAPI.removeOverlay(aMarkers[i]);
          aMarkers.splice(i, 1);
        }
      }
    },
    clearLoTimer() {
      if (this.loTimer != null) {
        clearTimeout(this.loTimer);
        this.loTimer = null;
      }
    },
    startBtnClick() {
      //如果是stop状态，则监控
      if (this.monitorStatus == "stop") {
        this.firstLo = true;
        this.startMonitor();
      }
      //如果是pause状态，则继续监控
      else if (this.monitorStatus == "pause") {
        this.startMonitor();
      }
      // 如果是paly状态，则暂停
      else if (this.monitorStatus == "play") {
        this.monitorStatus = "pause";
        this.clearLoTimer();
      }
    },
    stopLo() {
      this.monitorStatus = "stop";
      this.clearLoInfo();
    },
    startMonitor() {
      this.clearLoTimer();
      if (this.loIdsArr.length == 0) {
        this.$message({
          message: "请选择车辆",
          type: "warning"
        });
        return;
      }
      this.monitorStatus = "play";
      this.requestLo();
    },
    // 获取当前车辆所有信息
    requestLo() {
      this.treeLoading = true;
      request
        .fetchLocation({
          vehicleIdList: this.loIdsArr,
          lastTime: this.lastTime
        })
        .then(response => {
          if (
            (response.code =
              1 &&
              response.result &&
              response.result.vehicleLocationList &&
              response.result.vehicleLocationList.length > 0)
          ) {
            // // -----------------------ceshi------------------------------//
            // if (response.result.vehicleLocationList.length == 0) {
            //   this.loDatas_temp[0].lon += Math.random();
            //   this.loDatas_temp[0].lat += Math.random();
            //   this.loDatas_temp[0].gpsTime = moment(new Date()).format(
            //     "YYYY-MM-DD hh:mm:ss"
            //   );
            //   response.result.vehicleLocationList = [
            //     { ...this.loDatas_temp[0] }
            //   ];
            // }
            // // -----------------------ceshi------------------------------//

            this.lastTime = response.result.lastTime;
            response.result = JSON.parse(
              JSON.stringify(response.result.vehicleLocationList)
            );
            response.result = JSON.parse(
              JSON.stringify(this.handleTemperatureAndHumidity(response.result))
            );
            this.dealLo(response.result);
            if (this.settingcenter) {
              if (response.result.length) {
                let getCenterData =
                  response.result[Math.trunc(response.result.length / 2)];
                this.$refs.aLogisMap.mapAPI.setCenter(
                  this.$refs.aLogisMap.mapAPI.createLngLat({
                    lng84: getCenterData.lon,
                    lat84: getCenterData.lat
                  })
                );
              }
              this.settingcenter = false;
            }
          }
          this.refreshLo();
          // 处理树形列表loading
          this.treeLoading = false;
        })
        .catch(error => {
          this.refreshLo();
          console.log(error);
        });
    },
    // 处理温度和湿度，当值为 -999 的时候返回值为空
    handleTemperatureAndHumidity(data) {
      data.forEach(item => {
        for (let i = 1; i <= 4; i++) {
          if (item[`humidity${i}`] === -999) {
            item[`humidity${i}`] = "";
          }
          if (
            item[`temperature${i}`] === -999 ||
            item[`temperature${i}`] === -1
          ) {
            item[`temperature${i}`] = "";
          }
        }
      });
      return data;
    },
    // 循环刷新定位数据
    refreshLo() {
      this.loTimer = setTimeout(this.requestLo, this.refreshInterval * 1000);
    },
    /**
     * 处理定位数据
     * @param {array} aDatas 车辆定位数据列表
     */
    dealLo(aDatas) {
      if (aDatas.length == 0) {
        return;
      }
      this.$refs.aLogisMap.mapAPI.closeInfoWindow();
      //处理要绘制的点数据(更新marker)
      let updateIds = []; // 当前定位车辆的 id
      let updateMarkerDatas = aDatas.map(item => {
        if (item.lon != 0 && item.lat != 0) {
          updateIds.push(item.vehicleId);
          let iconStatus = this.getIconType(item); //获取图标状态类型（运行、停车、报警、异常）
          item.color = monitorJson.aColor[iconStatus]; //定义表格中每行数据的颜色
          item.iconStatus = iconStatus; // 当前车辆对应的 icon 状态
          // let winDetails =
          // "<div class='win-table'>" +
          // "<table>" +
          // "<tr><td><h2>车牌：</h2></td><td>" +
          // item.vehicleNo +
          // "</td></tr>" +
          // "<tr><td><h2>定位时间：</h2><td>" +
          // item.gpsTime +
          // "</td></tr>" +
          // "<tr><td><h2>里程：</h2><td>" +
          // item.odom +
          // " km</td></tr>" +
          // "<tr><td><h2>速度：</h2><td>" +
          // item.speed +
          // " km/h</td></tr>" +
          // "<tr><td><h2>位置：</h2><td>" +
          // item.position +
          // item.placeName +
          // item.roadName +
          // "</td></tr>" +
          // "<tr><td><h2>车辆状态：</h2><td>" +
          // item.gpsStatus +
          // "</td></tr>" +
          // "<tr><td><h2>报警状态：</h2><td>" +
          // item.alarmStatus +
          // "</td></tr>" +
          // "</table>" +
          // "</div>";
          // winDetails = addInfoWinOper(winDetails, {
          // addMaker: true,
          // gotoTrack: true
          // });
          return {
            llObj: { lng84: item.lon, lat84: item.lat },
            label: this.getLabel(item),
            icon: `e6Images/loCars/${this.iconType}/${iconStatus}_${Math.round(
              item.direction / 45
            ) % 8}${this.iconSize == "1" ? "" : "_s"}.png`,
            width: monitorJson.iconSize[this.iconSize].width,
            height: monitorJson.iconSize[this.iconSize].height,
            winDetails: this.getWinInfo_vehicle(item),
            extData: {
              id: item.vehicleId,
              vData: item
            }
          };
        }
      });
      // let aVehicleIDs_track = []; // 显示轨迹的车辆的id
      // 更新全部车辆数据 allLoDatas 为所有定位的数据
      // 增加逻辑判断当总数据等于0或小于获取的数据时更新数据
      if (
        this.allLoDatas.length == 0 ||
        this.allLoDatas.length < aDatas.length
      ) {
        this.allLoDatas = aDatas;
        this.allLoDatas = this.allLoDatas.map(item => {
          return { showTrack: false, ...item };
        });
      } else {
        // 如果 allLoDatas 存在，且与 aDatas 中的某个数据 vehicleId 相同时，
        // 用 aDatas 中的数据覆盖 allLoDatas中的数据，且 showTrack 为 allLoDatas 中的值
        aDatas.forEach(item1 => {
          this.allLoDatas.forEach(item2 => {
            if (item1.vehicleId == item2.vehicleId) {
              // item2 = JSON.parse(
              //   JSON.stringify({ showTrack: item2.showTrack, ...item1 })
              // );
              item2 = Object.assign(item2, item1);
              // 如果 showTrack 为真，则将该数据的 vehicleId 存入显示轨迹的车辆 id 中
              // if (item2.showTrack) {
              //   aVehicleIDs_track.push(item2.vehicleId.toString());
              // }
              // return true; // 证明该数据存在
            }
          });
          // if (!isExist) {
          //   // 如果不存在，则把该数据存入 allLoDatas
          //   this.allLoDatas.push({ showTrack: false, ...item1 });
          // }
        });
      }
      let allVehicleIdArr = [];
      //將markers中存储的line对象以及经纬度对象取出
      let trackLineObj = {};
      this.markers.forEach((item, index) => {
        let extData = this.$refs.aLogisMap.mapAPI.getExtData(item);
        let vData = extData.vData;
        if (item.aLnglat) {
          trackLineObj[vData.vehicleId] = {
            aLnglat: item.aLnglat,
            trackLine: item.trackLine ? item.trackLine : null
          };
        }
        allVehicleIdArr.push("a" + index + ":" + vData.vehicleId);
      });
      allVehicleIdArr = Array.from(new Set(allVehicleIdArr));
      // 从全部marker中删除此次需要更新的marker
      if (this.allMarkers.length > 0) {
        this.deleteMarkers(this.allMarkers, updateIds);
      }
      //从地图上的marker中删除此次要更新的marker（聚合的话则删除了所有聚合的点）
      this.removeMarkersFromMap(updateIds);
      //更新marker
      let updateMarkers = this.$refs.aLogisMap.createMarkers(updateMarkerDatas);
      this.allMarkers = [...this.allMarkers, ...updateMarkers];
      //更新的数据，如果状态已经改变不必更新到地图上，相反，原来地图上没有的，此次更新数据里有最近的状态和当前的tab 的情况相匹配，则也更新到地图上
      updateMarkers.forEach((item, i) => {
        let extData = this.$refs.aLogisMap.mapAPI.getExtData(item);
        let vData = extData.vData;
        // if (trackLineObj[vData.vehicleId]) {
        //   item.aLnglat = [...trackLineObj[vData.vehicleId].aLnglat];
        //   item.trackLine = trackLineObj[vData.vehicleId].trackLine;
        // }
        // 处理车辆显示的轨迹相关，不显示轨迹的则不处理（显示轨迹的，后续再按照此点是否在地图上显示，处理addOverlay其line）
        /*if (aVehicleIDs_track.includes(vData.vehicleId.toString())) {
          let lnglat =
            this.$refs.aLogisMap.mapAPI.getPosition(item).lnglat || null;
          if (lnglat) {
            if (!item.aLnglat) {
              item.aLnglat = [];
            }
            item.aLnglat.push(lnglat);
          }
          if (item.aLnglat && item.aLnglat.length >= 2) {
            // 数组的经纬度保留最大长度MAX_TRACK_LINE
            if (item.aLnglat.length > this.MAX_TRACK_LINE) {
              item.aLnglat.shift();
            }
            // 绘制线
            let trackLine = this.$refs.aLogisMap.mapAPI.createLine({
              path: item.aLnglat
            });
            if (item.trackLine) {
              this.$refs.aLogisMap.mapAPI.removeOverlay(item.trackLine);
            }
            item.trackLine = trackLine;
          }
        }*/
        // 新家在的数据数据marker如果再原数组marker里面有，则用新的marker替换旧的marker，如果没有，则直接添加到原marker数组中
        let isInFilter = this.isInTabFilter(vData);
        if (isInFilter) {
          for (let i = 0, len = allVehicleIdArr.length; i < len; i++) {
            let getCurrent = allVehicleIdArr[i].split(":");
            if (allVehicleIdArr[1] == vData.vehicleId) {
              let getIndex = Number(getCurrent[0].split("")[1]);
              this.markers.splice(getIndex, 1, item);
            } else {
              this.markers.push(item);
            }
          }
          if (item.trackLine) {
            this.$refs.aLogisMap.mapAPI.addOverlay(item.trackLine);
          }
        }
      });
      // 将markers的数据添加到地图上
      this.addMarkersToMap();
      //处理表格
      this.dealTable();
      //处理监控模式
      this.dealMonitorMode();
      // 使聚合与tab数据同步
      if (this.isShow_cluster) {
        this.statTabChange(this.selectOpts || this.statTabList[0]);
      }
      // 处理tab及数字
      this.dealTabNum();

      // 处理树形列表loading
      this.treeLoading = false;
    },
    getLabel(vData) {
      let aLabel = [];
      if (this.isShow_vehicleName) {
        aLabel.push(vData.vehicleNo);
      }
      if (this.isShow_time) {
        aLabel.push(vData.gpsTime);
      }
      if (this.isShow_speed) {
        aLabel.push(vData.speed + "km/h");
      }
      return aLabel.join(" ");
    },
    // 判断marker是否在此次tab过滤的应显示的范围内
    isInTabFilter(vData) {
      let isIn = false;
      let tabInActive = this.statTabList.find(item => {
        return item.isActive;
      });
      switch (tabInActive.selected.classify) {
        case "all":
          isIn = true;
          break;
        case "run":
          if (
            (vData.exceptionType == 0 || !(vData.exceptionType & 2)) &&
            (vData.gpsStatus.indexOf("acc开") >= 0 ||
              vData.gpsStatus.indexOf("acc") < 0) &&
            vData.speed > 0
          ) {
            isIn = true;
          }
          break;
        case "stop":
          if (
            (vData.exceptionType == 0 || !(vData.exceptionType & 2)) &&
            !(
              (vData.gpsStatus.indexOf("acc开") >= 0 ||
                vData.gpsStatus.indexOf("acc") < 0) &&
              vData.speed > 0
            )
          ) {
            isIn = true;
          }
          break;
        case "alarm":
          monitorJson.alarmType_first.some(item => {
            if ((vData.alarmType & item) == item) {
              isIn = true;
            }
          });
          break;
        case "abnormal":
          monitorJson.expType_first.some(item => {
            if ((vData.exceptionType & item) == item) {
              isIn = true;
            }
          });
          break;
        default:
          if (tabInActive.type == "停车") {
            isIn = this.isInTabFilter_stop(vData, tabInActive);
          } else if (tabInActive.type == "报警") {
            isIn = this.isInTabFilter_alarm(vData, tabInActive);
          } else if (tabInActive.type == "异常") {
            isIn = this.isInTabFilter_abnormal(vData, tabInActive);
          }
          break;
      }
      return isIn;
    },
    //是否包括在stop子类中
    isInTabFilter_stop(vData, tabInActive) {
      let isIn = false;
      // 停车 = !运行
      if (
        (vData.exceptionType == 0 || !(vData.exceptionType & 2)) &&
        !(
          (vData.gpsStatus.indexOf("acc开") >= 0 ||
            vData.gpsStatus.indexOf("ACC") < 0) &&
          vData.speed > 0
        )
      ) {
        // 停车未熄火
        if (
          tabInActive.selected.classify == 8 &&
          vData.gpsStatus.indexOf("acc开") >= 0 &&
          vData.speed == 0
        ) {
          isIn = true;
        } else {
          // 已停车
          if (
            tabInActive.selected.classify == 4 &&
            !(vData.gpsStatus.indexOf("acc开") >= 0 && vData.speed == 0)
          ) {
            isIn = true;
          }
        }
      }
      return isIn;
    },
    //是否包括在alarm子类中
    isInTabFilter_alarm(vData, tabInActive) {
      let isIn = false;
      let aAlarm_second = vData.alarmTypeStr.split(",");
      if (aAlarm_second.includes(tabInActive.selected.classify)) {
        isIn = true;
      }
      return isIn;
    },
    //是否包括在abnormal子类中
    isInTabFilter_abnormal(vData, tabInActive) {
      let isIn = false;
      let aAbnormal_second = vData.exceptionTypeStr.split(",");
      if (aAbnormal_second.includes(tabInActive.selected.classify)) {
        isIn = true;
      }
      return isIn;
    },
    getIconType(vData) {
      // 图标类型: 'run','stop','alarm','abnormal'
      const ICON_TYPE = "stop";
      let iconStatus = ICON_TYPE;
      // 是否"alarm"
      monitorJson.alarmType_first.some(item => {
        if ((vData.alarmType & item) == item) {
          iconStatus = "alarm";
          return true;
        }
      });
      // 是否"abnormal"
      if (iconStatus == ICON_TYPE) {
        monitorJson.expType_first.some(item => {
          if ((vData.exceptionType & item) == item) {
            iconStatus = "abnormal";
            return true;
          }
        });
      }
      // 是否"run"
      if (iconStatus == ICON_TYPE) {
        if (
          (vData.gpsStatus.indexOf("acc开") >= 0 ||
            vData.gpsStatus.indexOf("acc") < 0) &&
          vData.speed > 0
        ) {
          iconStatus = "run";
        }
      }
      return iconStatus;
    },
    dealTable(tDatas) {
      if (tDatas) {
        this.tableDatas = tDatas;
      } else {
        this.tableDatas = this.allLoDatas.filter(item => {
          return this.isInTabFilter(item);
        });
      }
      this.$nextTick(() => {
        this.selectedRow.forEach(row => {
          this.$refs.vehicleTable.toggleRowSelection(row, true);
        });
      });
    },
    dealTabNum() {
      // 删除统计数据的children，重新计算（保留isActive，以及selected，后续selected的数字会重新赋值）
      this.statTabList.forEach(item => {
        if (item.children) {
          delete item.children;
        }
      });

      let tempTabNumArr = {};
      // 循环数据，处理“运行” + “二级分类”
      this.allLoDatas.forEach(item => {
        // 全部
        this.addNumByClassify(tempTabNumArr, {
          name: "全部",
          classify: "all",
          type: "全部"
        });
        //异常
        if (item.exceptionTypeStr && item.exceptionTypeStr != "") {
          let tempTypeArr_exp = item.exceptionTypeStr.split(",");
          tempTypeArr_exp.forEach((item_exp, index_exp) => {
            if (index_exp == 0) {
              this.addNumByClassify(tempTabNumArr, {
                name: "全部",
                classify: "abnormal",
                type: "异常"
              });
            }
            this.addNumByClassify(tempTabNumArr, {
              name: monitorJson.expType[item_exp],
              classify: item_exp,
              type: "异常"
            });
          });
        }
        //报警
        if (item.alarmTypeStr && item.alarmTypeStr != "") {
          let tempTypeArr_alarm = item.alarmTypeStr.split(",");
          tempTypeArr_alarm.forEach((item_alarm, index_alarm) => {
            if (index_alarm == 0) {
              this.addNumByClassify(tempTabNumArr, {
                name: "全部",
                classify: "alarm",
                type: "报警"
              });
            }
            this.addNumByClassify(tempTabNumArr, {
              name: monitorJson.alarmType[item_alarm],
              classify: item_alarm,
              type: "报警"
            });
          });
        }
        // 运行 & 停车（exceptionType中2是掉线，掉线则不算入运行或停车中）
        if (item.exceptionType == 0 || !(item.exceptionType & 2)) {
          // 运行
          if (
            (item.gpsStatus.indexOf("acc开") >= 0 ||
              item.gpsStatus.indexOf("acc") < 0) &&
            item.speed > 0
          ) {
            this.addNumByClassify(tempTabNumArr, {
              name: "全部",
              classify: "run",
              type: "运行"
            });
          }
          // 停车
          else {
            this.addNumByClassify(tempTabNumArr, {
              name: "全部",
              classify: "stop",
              type: "停车"
            });
            //停车未熄火
            if (item.gpsStatus.indexOf("acc开") >= 0 && item.speed == 0) {
              this.addNumByClassify(tempTabNumArr, {
                name: monitorJson.stopType["8"],
                classify: "8",
                type: "停车"
              });
            }
            //已停车
            else {
              this.addNumByClassify(tempTabNumArr, {
                name: monitorJson.stopType["4"],
                classify: "4",
                type: "停车"
              });
            }
          }
        }
      });

      //根据二级分类处理tab显示
      for (let key in tempTabNumArr) {
        let item1 = tempTabNumArr[key];
        this.statTabList.some(item2 => {
          if (item1.type == item2.type) {
            if (item2.selected.classify == item1.classify) {
              item2.selected = { ...item1 };
            }
            if (
              item2.type == "停车" ||
              item2.type == "报警" ||
              item2.type == "异常"
            ) {
              if (!item2.children) {
                item2.children = [];
              }
              if (item1.name == "全部") {
                item2.children.unshift({ ...item1 });
              } else {
                item2.children.push({ ...item1 });
              }
            }
            return true;
          }
        });
      }
    },
    //添加tab上的数字
    addNumByClassify(tempArr, opts) {
      let key = `${opts.type}_${opts.classify}`;
      if (!tempArr[key]) {
        tempArr[key] = { num: 1, ...opts };
      } else {
        tempArr[key].num++;
      }
    },
    dealMonitorMode() {
      // 首次定位 or “全部车辆”模式 or “单车监控”下车辆Id为-1
      if (
        this.firstLo ||
        this.monitorMode == 1 ||
        (this.monitorMode == 3 && this.singleVehicle.vehicleId == -1)
      ) {
        //将所有车辆设置在可视范围之内
        // this.$refs.aLogisMap.mapAPI.setFitView({ overlayList: this.markers });
        this.setMonitorMode(1);
        // 首次定位，将全部车辆展示在可视范围之内后，将地图设置成“固定地图”模式
        if (this.firstLo) {
          this.setMonitorMode(2);
        }
        this.firstLo = false;
      } else if (this.monitorMode == 3 && this.singleVehicle.vehicleId != -1) {
        //单车模式
        this.setMonitorMode(3, { ...this.singleVehicle });
      }
    },
    // 设置监控模式（1-全部车辆；2-固定地图；3-单车监控）
    setMonitorMode(mMode, opts) {
      this.monitorMode = mMode;
      let marker = null;
      switch (mMode) {
        case 1:
          this.isTriggerMove = false;
          this.$refs.aLogisMap.mapAPI.setFitView({ overlayList: this.markers });
          this.singleVehicle = {
            vehicleId: -1,
            vehicleNo: ""
          };
          break;
        case 2:
          this.singleVehicle = {
            vehicleId: -1,
            vehicleNo: ""
          };
          break;
        case 3:
          this.isTriggerMove = false;
          this.singleVehicle = { ...opts };
          marker = this.markers.find(item => {
            let extData = this.$refs.aLogisMap.mapAPI.getExtData(item);
            return extData.id == opts.vehicleId;
          });
          // 如果左下角tab过滤完后，地图上没有单车的点，则不设置中心点
          if (marker != null) {
            let pos = this.$refs.aLogisMap.mapAPI.getPosition(marker);
            this.$refs.aLogisMap.mapAPI.setCenter(pos.lnglat);
          }
          break;
        default:
          break;
      }
    },
    // 打开信息窗口
    openInfoWin(vID) {
      let marker = this.markers.find(item => {
        let extData = this.$refs.aLogisMap.mapAPI.getExtData(item);
        return extData.id == vID;
      });
      if (marker) {
        this.$refs.aLogisMap.mapAPI.openInfoWindow(marker);
      }
    },
    clearLoInfo() {
      this.clearLoTimer();
      this.changeTableStatus("min");
      if (this.isShow_cluster) {
        // 聚合
        this.$refs.aLogisMap.mapAPI.removeOverlay(this.cluster);
      } else {
        // 普通marker
        this.markers.forEach(item => {
          if (item.trackLine) {
            this.$refs.aLogisMap.mapAPI.removeOverlay(item.trackLine);
          }
          this.$refs.aLogisMap.mapAPI.removeOverlay(item);
        });
      }
      this.$refs.aLogisMap.mapAPI.closeInfoWindow();
      this.markers = [];
      this.cluster = null;
      this.allMarkers = [];
      this.loIdsArr = [];
      this.allLoDatas = [];
      this.tableDatas = [];
      this.selectedRow = [];
      this.monitorMode = 1;
      this.singleVehicle = { vehicleId: -1, vehicleNo: "" };
      this.isTriggerMove = true;
      this.firstLo = true;
      this.statTabList = JSON.parse(JSON.stringify(this.STAT_TAB_LIST));
      this.lastTime = 0;
      this.$refs.vehicleTree.setAllNodeCheck(false);
      this.monitorStatus = "stop";
    },
    treeSearch() {
      if (this.searchTxt != "") {
        this.$refs.vehicleTree.setAllNodexExpand();
        this.$refs.vehicleTree.queryTreeNodeByName(this.searchTxt);
      } else {
        this.$refs.vehicleTree.setAllNodeSelect(false);
      }
    },
    cancelSetting() {
      this.dialogShow_setting = false;
      // 将操作项还原
      this.loSetting.isShow_vehicleName = this.isShow_vehicleName;
      this.loSetting.isShow_time = this.isShow_time;
      this.loSetting.isShow_speed = this.isShow_speed;
      this.loSetting.isShow_cluster = this.isShow_cluster;
      this.loSetting.iconSize = this.iconSize;
      this.loSetting.refreshInterval = this.refreshInterval;
      this.loSetting.showColsList = JSON.parse(
        JSON.stringify(this.showColsList)
      );
      let showColsList_Ids = this.loSetting.showColsList.map(item => {
        return item.value;
      });
      this.loSetting.hideColsList = monitorJson.tableCols.filter(item => {
        return !showColsList_Ids.includes(item.value);
      });
    },
    saveSetting() {
      let settingObj = {
        showSettingStatus: 0,
        tableSetting: "",
        mointRefreshTime: 10
      };
      if (this.loSetting.isShow_vehicleName) {
        settingObj.showSettingStatus += 1;
      }
      if (this.loSetting.isShow_time) {
        settingObj.showSettingStatus += 2;
      }
      if (this.loSetting.isShow_speed) {
        settingObj.showSettingStatus += 4;
      }
      if (this.loSetting.isShow_cluster) {
        settingObj.showSettingStatus += 8;
      }
      //1 - 大图标
      if (this.loSetting.iconSize == "1") {
        settingObj.showSettingStatus += 16;
      }
      settingObj.isShowSafeEvent = 0; // 主动安全设置选项，页面中已经去掉，但是接口未改，直接给0
      settingObj.tableSetting = this.loSetting.showColsList
        .map(item => {
          return item.value;
        })
        .join(",");
      settingObj.mointRefreshTime = this.loSetting.refreshInterval;
      request
        .saveSetting(settingObj)
        .then(response => {
          if (response.code == 1) {
            this.$message({
              message: response.message,
              type: "success"
            });
            this.dialogShow_setting = false;
            this.fetchSetting();
          } else {
            this.$message({
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeTableStatus(wType) {
      this.tableWinType = wType;
      switch (wType) {
        case "min":
          this.height_table = 0;
          break;
        case "win":
          this.height_table = this.HEIGHT_WIN_TABLE;
          break;
        case "max":
          this.height_table =
            document.querySelector(".mContainer").clientHeight -
            document.querySelector(".resizer-drag").clientHeight -
            document.querySelector(".top").clientHeight;
          break;
      }
    },
    foldRight() {
      this.isFold_right = !this.isFold_right;
      this.pageResize();
    },
    //获取车辆树
    fetchVehicleTree(dicId) {
      request
        .fetchVehicleTree(this.$qs.stringify({ transType: dicId }))
        .then(response => {
          if (response.code == 1 && response.result) {
            this.treeList = response.result;
            this.treeList[0]["open"] = true;
            this.dealTreeList_timeSearch();
            if (this.$route.query.companyId) {
              this.companyId = this.$route.query.companyId;
              let id = "S_" + this.companyId;
              /**
               * 如果是从企业监控跳转进入，先拿到传入的企业id,再通过id拿到节点对象，最后设置选中
               */
              this.$nextTick(() => {
                let nodes = this.$refs.vehicleTree.queryTreeNodeByID(id);
                nodes.forEach(node => {
                  this.$refs.vehicleTree.setNodeCheck(node);
                });
                this.$nextTick(() => {
                  let opts = this.$refs.vehicleTree.getAllNodes(true, false); //获取所有勾选的节点（叶子节点与非叶子节点）
                  this.loIdsArr = opts.ids;
                  nodes.length > 0 && this.startBtnClick();
                });
              });
            }
          } else {
            this.$message({
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    fetchSetting() {
      request
        .fetchSetting()
        .then(response => {
          if (response.code == 1 && response.result) {
            let settingObj = response.result;
            // 设置层中变量
            this.loSetting.isShow_vehicleName =
              (settingObj.showSettingStatus & 1) == 1; //车牌
            this.loSetting.isShow_time =
              (settingObj.showSettingStatus & 2) == 2; //时间
            this.loSetting.isShow_speed =
              (settingObj.showSettingStatus & 4) == 4; //速度
            this.loSetting.isShow_cluster =
              (settingObj.showSettingStatus & 8) == 8; //车辆聚合
            this.loSetting.iconSize =
              (settingObj.showSettingStatus & 16) == 16 ? "1" : "0"; //图标大小（默认小图标，16为大图标）
            //刷新间隔
            this.loSetting.refreshInterval = settingObj.mointRefreshTime;
            //处理表格列相关
            this.loSetting.showColsList = [];
            this.loSetting.hideColsList = [];
            let aCols_show = settingObj.tableSetting.split(",") || [];
            monitorJson.tableCols.forEach(item => {
              if (item.disabled || aCols_show.includes(item.value)) {
                let index = aCols_show.findIndex(value => {
                  return item.value == value;
                });
                this.loSetting.showColsList.splice(index, 0, item);
              } else {
                this.loSetting.hideColsList.push({ ...item });
              }
            });
            // 真正使用的变量
            let vehicleName_pre = this.isShow_vehicleName;
            let time_pre = this.isShow_time;
            let speed_pre = this.isShow_speed;
            let iconSize_pre = this.iconSize;
            let isShow_cluster_pre = this.isShow_cluster;
            let showColsStr_pre = this.showColsList
              .map(item => {
                return item.value;
              })
              .join(",");

            this.isShow_vehicleName = this.loSetting.isShow_vehicleName;
            this.isShow_time = this.loSetting.isShow_time;
            this.isShow_speed = this.loSetting.isShow_speed;
            this.isShow_cluster = this.loSetting.isShow_cluster;
            this.iconSize = this.loSetting.iconSize;
            this.refreshInterval = this.loSetting.refreshInterval;
            this.showColsList = JSON.parse(
              JSON.stringify(this.loSetting.showColsList)
            );
            // 如果定位中，则更新相关状态
            if (this.monitorStatus == "play") {
              //处理表格列设置变化之后，表格错乱行问题。（重新渲染后，表格行就不错乱了，so，重新渲染一遍）
              if (showColsStr_pre != settingObj.tableSetting) {
                let tempDatas = this.tableDatas;
                this.tableDatas = [];
                this.$nextTick(() => {
                  this.dealTable(tempDatas);
                });
              }
              // 处理marker显示
              if (
                vehicleName_pre != this.isShow_vehicleName ||
                time_pre != this.isShow_time ||
                speed_pre != this.isShow_speed ||
                iconSize_pre != this.iconSize ||
                isShow_cluster_pre != this.isShow_cluster
              ) {
                this.changeMapBySetting({
                  isChange_cluster: isShow_cluster_pre != this.isShow_cluster
                });
              }
            }
          } else {
            this.$message({
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    changeMapBySetting(opts) {
      // play时，需要处理地图上点（pause时，再play的时候会根绝设置进行处理，这里无需处理）
      if (this.monitorStatus == "play") {
        // 只需要修改allMarkers中marker中的值，因为allMarkers和markers赋值为引用，指向的是同一个对�����
        this.allMarkers.forEach(item => {
          let extData = this.$refs.aLogisMap.mapAPI.getExtData(item);
          let vData = extData.vData;
          //若果车辆图标大小改变
          let iconStatus = this.getIconType(vData);
          let icon = `e6Images/loCars/${
            this.iconType
          }/${iconStatus}_${Math.round(vData.direction / 45) % 8}${
            this.iconSize == "1" ? "" : "_s"
          }.png`;
          this.$refs.aLogisMap.mapAPI.setIcon(item, {
            labelStr: this.getLabel(vData),
            icon,
            width: monitorJson.iconSize[this.iconSize].width,
            height: monitorJson.iconSize[this.iconSize].height
          });
        });
        // 处理聚合
        if (opts.isChange_cluster) {
          if (this.isShow_cluster) {
            //删除地图上原来的非聚合点
            this.markers.forEach(item => {
              this.$refs.aLogisMap.mapAPI.removeOverlay(item);
            });
          } else {
            if (this.cluster) {
              this.$refs.aLogisMap.mapAPI.removeOverlay(this.cluster);
            }
          }
          this.addMarkersToMap();
        }
      }
    },
    mapInitBack_monitor() {
      this.$refs.aLogisMap.mapAPI.addListener_move(() => {
        if (this.monitorStatus == "stop") {
          return;
        }
        //如果是设置单车监控的中心点触发，则不设置固定地图模式
        if (this.isTriggerMove) {
          this.setMonitorMode(2);
        } else {
          this.isTriggerMove = true;
        }
      });
      // this.mapInitBack();
    },
    // 表格行点击事件，显示车辆具体信息窗口
    rowClick(rowData) {
      this.setSingleOpenWin({
        vehicleId: rowData.vehicleId,
        vehicleNo: rowData.vehicleNo
      });
    },
    rowCssRender(opts) {
      return `row_${opts.row.iconStatus}`;
    },
    resizerMove(top) {
      this.tableWinType = "win";
      this.height_table =
        document.querySelector(".mContainer").clientHeight -
        top -
        document.querySelector(".resizer-drag").clientHeight -
        document.querySelector(".top").clientHeight;
    },
    // 列表中checkbox选择事件
    rowSelect_all(selection) {
      let isCheck = false; //是否选中
      if (selection.length == 0) {
        // 全部取消
        isCheck = false;
      } else {
        // 全部选中
        isCheck = true;
      }
      // 只需修改allLoDatas的值，tableDatas中的数据相应会变化。tableDatas是通过filter的方式从allLoDatas中过滤出来的，相关指针依然指向同一块内存
      this.allLoDatas.forEach(item => {
        item.showTrack = isCheck;
      });
    },
    rowSelect(selection, row) {
      let isCheck = false; //是否选中
      isCheck =
        selection.findIndex(item => {
          return item.vehicleId == row.vehicleId;
        }) < 0
          ? false
          : true;
      this.selectedRow = selection;
      // 只需修改allLoDatas的值，tableDatas中的数据相应会变化。tableDatas是通过filter的方式从allLoDatas中过滤出来的，相关指针依然指向同一块内存
      this.allLoDatas.some(item => {
        if (item.vehicleId == row.vehicleId) {
          item.showTrack = isCheck;
          return true;
        }
      });
      //取消的时候删除line，以及删除marker中存储line的对象。选中的时候不绘制线，下次请求回来的时候绘制。
      // if (!isCheck) {
      // marker的数据是从allMarkers中过滤后直接push来的，push 的直接是marker对象，所以其指针指向通一块内存
      this.markers.some(item => {
        let extData = this.$refs.aLogisMap.mapAPI.getExtData(item);
        if (extData.id == row.vehicleId) {
          if (isCheck) {
            let lnglat =
              this.$refs.aLogisMap.mapAPI.getPosition(item).lnglat || null;
            if (lnglat) {
              if (!item.aLnglat) {
                item.aLnglat = [];
              }
              item.aLnglat.push(lnglat);
            }
          } else {
            if (item.trackLine) {
              this.$refs.aLogisMap.mapAPI.removeOverlay(item.trackLine);
              delete item.trackLine;
              delete item.aLnglat;
            }
          }
          return true;
        }
      });
      // }
    },
    // 导出
    exportExcel() {
      if (this.loIdsArr.length == 0) {
        this.$message({
          message: "没有要导出的车辆",
          type: "warning"
        });
        return;
      }
      request.exportExcel({
        vehicleList: this.loIdsArr
      });
    },
    // 指令下发相关
    treeSearch_directive() {
      if (this.searchTxt_directive != "") {
        this.$refs.directiveTree.queryTreeNodeByName(this.searchTxt_directive);
      } else {
        this.$refs.directiveTree.setAllNodeSelect(false);
      }
    },
    openDirectiveLayer(type) {
      this.title_directive = this.titleObj_directive[type];
      this.layerType_directive = type;
      this.dialogShow_directive = true;
      this.isShow_moreFun = false;
    },
    closeDirectiveLayer() {
      this.dialogShow_directive = false;
      switch (this.layerType_directive) {
        case "photo":
          this.checkList_photo = [];
          break;
        case "lcd":
          this.info_lcd = {
            isShow_msg: false,
            isShow_new: false,
            newMsg: "",
            message: "",
            isCheck_save: false,
            maxlength: 100,
            restNum: 0
          };
          break;
        case "call":
          break;
        case "sd":
          this.form_sd = {
            startTime: moment(new Date()).valueOf(),
            interval: 10,
            totalNum: 10,
            checkList: []
          };
          break;
        default:
          break;
      }
      this.layerType_directive = "";
      this.title_directive = "";
      this.$refs.directiveTree.setAllNodeCheck(false);
    },
    // isChk：是否checkbox，chk则返回数组，否则返回选中id
    getSelectedIDsOfTree_directive(isChk) {
      let opts = this.$refs.directiveTree.getAllNodes(true, false);
      if (!isChk) {
        return opts.ids[0] || 0;
      } else {
        return opts.ids;
      }
    },
    // 拍照指令
    sendDirective_photo() {
      let vehicleId = this.getSelectedIDsOfTree_directive(false);
      let cameraChannel = 0;
      if (this.checkList_photo.length > 0) {
        cameraChannel = this.checkList_photo.reduce((total, cur) => {
          return total + cur;
        });
      }
      if (vehicleId == 0) {
        this.$message({
          message: "请选择车辆",
          type: "warning"
        });
        return;
      }
      if (cameraChannel == 0) {
        this.$message({
          message: "请选择摄像头",
          type: "warning"
        });
        return;
      }
      request
        .sendDirective_photo({ vehicleId, cameraChannel })
        .then(response => {
          if (response.code == 1) {
            this.$message({
              message: response.message,
              type: "success"
            });
            this.closeDirectiveLayer();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // lcd短信
    sendDirective_lcd() {
      let vehicleIdList = this.getSelectedIDsOfTree_directive(true);
      if (vehicleIdList.length == 0) {
        this.$message({
          message: "请选择车辆",
          type: "warning"
        });
        return;
      }
      if (this.info_lcd.message == "") {
        this.$message({
          message: "请填写短信内容",
          type: "warning"
        });
        return;
      }
      if (this.info_lcd.restNum < 0) {
        this.$message({
          message: "短信内容最多100字",
          type: "warning"
        });
        return;
      }
      request
        .sendDirective_lcd({
          vehicleIdList,
          messageContent: this.info_lcd.message,
          isSaveMessage: Number(this.info_lcd.isCheck_save)
        })
        .then(response => {
          if (response.code == 1) {
            this.$message({
              message: response.message,
              type: "success"
            });
            if (this.info_lcd.isCheck_save) {
              this.fetchMsg_lcd();
            }
            this.closeDirectiveLayer();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    openMsgList_lcd() {
      this.info_lcd.isShow_msg = !this.info_lcd.isShow_msg;
    },
    openNewMsg_lcd() {
      this.info_lcd.isShow_new = true;
    },
    closeNewMsg_lcd() {
      this.info_lcd.newMsg = "";
      this.info_lcd.isShow_new = false;
    },
    saveNewMsg_lcd() {
      if (this.info_lcd.newMsg == "") {
        this.$message({
          message: "请输入短信内容",
          type: "warning"
        });
        return;
      }
      request
        .saveNewMsg_lcd({ messageContent: this.info_lcd.newMsg })
        .then(response => {
          if (response.code == 1) {
            this.$message({
              message: response.message,
              type: "success"
            });
            this.closeNewMsg_lcd();
            this.fetchMsg_lcd();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    fetchMsg_lcd() {
      // request
      //   .fetchMsg_lcd()
      //   .then(response => {
      //     if (response.code == 1 && response.result) {
      //       this.msgList_lcd = JSON.parse(JSON.stringify(response.result));
      //     }
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },
    deleteMsg_lcd(delId) {
      if (delId) {
        request
          .deleteMsg_lcd({ delId })
          .then(response => {
            if (response.code == 1) {
              this.$message({
                message: response.message,
                type: "success"
              });
              this.fetchMsg_lcd();
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    selectOneMsg_lcd(message) {
      this.info_lcd.message = message;
    },
    // 点名
    sendDirective_call() {
      let vehicleIdList = this.getSelectedIDsOfTree_directive(true);
      if (vehicleIdList.length == 0) {
        this.$message({
          message: "请选择车辆",
          type: "warning"
        });
        return;
      }
      request
        .sendDirective_call({ vehicleIdList })
        .then(response => {
          if (response.code == 1) {
            this.$message({
              message: response.message,
              type: "success"
            });
            this.closeDirectiveLayer();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // SD卡照片提取
    sendDirective_sd() {
      let vehicleId = this.getSelectedIDsOfTree_directive(false);
      let cameraChannel = 0;
      if (this.form_sd.checkList.length > 0) {
        cameraChannel = this.form_sd.checkList.reduce((total, cur) => {
          return total + cur;
        });
      }
      if (vehicleId == 0) {
        this.$message({
          message: "请选择车辆",
          type: "warning"
        });
        return;
      }
      if (!this.form_sd.startTime) {
        this.$message({
          message: "请选择开始时间",
          type: "warning"
        });
        return;
      }
      if (cameraChannel == 0) {
        this.$message({
          message: "请选择拍照方式",
          type: "warning"
        });
        return;
      }
      request
        .sendDirective_sd({
          vehicleId,
          cameraChannel,
          beginTime: this.form_sd.startTime,
          timeInterval: this.form_sd.interval,
          photoCount: this.form_sd.totalNum
        })
        .then(response => {
          if (response.code == 1) {
            this.$message({
              message: response.message,
              type: "success"
            });
            this.closeDirectiveLayer();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 时间点查车
    dealTreeList_timeSearch(list) {
      let treeList = list || this.treeList;
      treeList.forEach(item => {
        if (!item.disabled) {
          // 车是叶子节点，只把车过滤过来
          this.vehicleList_timeSearch.push(item);
        } else if (item.children) {
          // item.disabled == true,是部门节点，也有空部门，部门底下没有children车的情况
          this.dealTreeList_timeSearch(item.children);
        }
      });
    },
    openTimeSearch() {
      this.isShow_moreFun = false;
      this.$refs.timeSearchLayer.showBox();
    },
    closeTimeSearch() {
      this.form_timeSearch = {
        time: moment(new Date()).valueOf(),
        vehicleId: ""
      };
      this.clearMap_timeSearch();
    },
    fetchVehicle_timeSearch() {
      if (!this.form_timeSearch.time) {
        this.$message({
          message: "请选择时间",
          type: "warning"
        });
        return;
      }
      if (this.form_timeSearch.vehicleId == "") {
        this.$message({
          message: "请选择车辆",
          type: "warning"
        });
        return;
      }
      request
        .fetchVehicle_timeSearch({
          vehicleId: this.form_timeSearch.vehicleId,
          gpsTime: this.form_timeSearch.time
        })
        .then(response => {
          if (response.code == 1 && response.result) {
            let vData = response.result;
            // 绘制查询出来的车辆
            this.clearMap_timeSearch();
            let winDetails =
              "<div class='win-table'>" +
              "<table>" +
              "<tr><td><h2>车牌：</h2></td><td>" +
              vData.vehicleNo +
              "</td></tr>" +
              "<tr><td><h2>定位时间：</h2><td>" +
              moment(vData.gpsTime).format("YYYY-MM-DD hh:mm:ss") +
              "</td></tr>" +
              "<tr><td><h2>里程：</h2><td>" +
              vData.odom +
              " km</td></tr>" +
              "<tr><td><h2>速度：</h2><td>" +
              vData.speed +
              " km/h</td></tr>" +
              "<tr><td><h2>位置：</h2><td>" +
              vData.position +
              "</td></tr>" +
              "<tr><td><h2>状态：</h2><td>" +
              vData.status +
              "</td></tr>" +
              "</table>" +
              "</div>";
            // winDetails = addInfoWinOper(winDetails, {
            //   addMaker: true,
            //   gotoTrack: true
            // });
            let opts = {
              position: this.$refs.aLogisMap.mapAPI.createLngLat({
                lng84: vData.lon,
                lat84: vData.lat
              }),
              width: 33,
              height: 40,
              icon: "e6Images/point.png",
              label: vData.vehicleNo,
              winDetails,
              offsetType: 1
            };
            this.marker_timeSearch = this.$refs.aLogisMap.mapAPI.createMarker(
              opts
            );
            this.$refs.aLogisMap.mapAPI.addOverlay(this.marker_timeSearch);
            this.$refs.aLogisMap.mapAPI.setFitView({
              overlayList: [this.marker_timeSearch]
            });
          } else {
            this.$message({
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    clearMap_timeSearch() {
      if (this.marker_timeSearch != null) {
        this.$refs.aLogisMap.mapAPI.removeOverlay(this.marker_timeSearch);
        this.marker_timeSearch = null;
      }
    },
    // 拉框查找 - 找已经定位的车
    drawRectToSearch_lo_pullRect() {
      if (this.monitorStatus == "stop") {
        this.$message({
          message: "请先定位车辆再进行查询",
          type: "warning"
        });
        return;
      }
      this.clearDatas_lo_pullRect();
      this.pullRect.title = "查找已经定位车";
      this.$refs.aLogisMap.mapAPI.drawOverlay({
        type: "rectangle",
        callback: overlay => {
          this.pullRect.rect = overlay;
          let maxMin = this.$refs.aLogisMap.mapAPI.getMaxMin(overlay);
          this.pullRect.maxMin = maxMin;
          this.fetchLoVehiclesByPullRect();
        }
      });
    },
    fetchLoVehiclesByPullRect() {
      let maxMin = this.pullRect.maxMin;
      let aLnglat = [
        [maxMin.sw.lng, maxMin.ne.lat],
        [maxMin.ne.lng, maxMin.ne.lat],
        [maxMin.ne.lng, maxMin.sw.lat],
        [maxMin.sw.lng, maxMin.sw.lat]
      ];
      let datas = this.allLoDatas.filter(item => {
        let lnglat = this.$refs.aLogisMap.mapAPI.createLngLat({
          lng84: item.lon,
          lat84: item.lat
        });
        return this.$refs.aLogisMap.mapAPI.isPointInRing(lnglat, aLnglat);
      });
      if (datas.length > 0) {
        this.pullRect.datas = datas;
        this.$refs.pullRectLayer.showBox();
      } else {
        this.$message({
          message: "没有找到相关车辆",
          type: "warning"
        });
        this.clearDatas_lo_pullRect();
      }
    },
    clearDatas_lo_pullRect() {
      if (this.pullRect.rect != null) {
        this.$refs.aLogisMap.mapAPI.removeOverlay(this.pullRect.rect);
      }
      if (this.pullRect.marker != null) {
        this.$refs.aLogisMap.mapAPI.closeInfoWindow(this.pullRect.marker);
        // this.$refs.aLogisMap.mapAPI.removeOverlay(this.pullRect.marker);
      }
      this.pullRect = {
        title: "",
        maxMin: {},
        marker: null,
        rect: null,
        datas: []
      };
    },
    closeListLayer_lo_pullRect() {
      this.clearDatas_lo_pullRect();
    },
    rowClick_lo_pullRect(row) {
      let marker = this.markers.find(item => {
        let extData = this.$refs.aLogisMap.mapAPI.getExtData(item);
        return row.vehicleId == extData.vData.vehicleId;
      });
      this.pullRect.marker = marker;
      if (marker) {
        this.$refs.aLogisMap.mapAPI.openInfoWindow(marker);
      }
    },
    exportExcel_lo_pullRect() {
      if (this.pullRect.datas.length == 0) {
        this.$message({
          message: "没有要导出的数据",
          type: "warning"
        });
        return;
      }
      let aIds = this.pullRect.datas.map(item => {
        return item.vehicleId;
      });
      request.exportExcel_pullRect({
        vehicleIdList: aIds
      });
    },
    // 主动安全
    fetchCount_safeEvent() {
      // request.fetchCount_safeEventApi().then(res => {
      //   if (res.code == 1 && res.result) {
      //     this.safeEvent.count = res.result.count;
      //   }
      // });
      // this.safeEvent.timer = setTimeout(() => {
      //   this.fetchCount_safeEvent();
      // }, this.REFRESH_NUM_SAFEEVENT);
    },
    clearTimer_safeEvent() {
      if (this.safeEvent.timer != null) {
        clearTimeout(this.safeEvent.timer);
        this.safeEvent.timer = null;
      }
    },
    fetchList_safeEvent() {
      request.fetchList_safeEventApi().then(res => {
        if (res.code == 1 && res.result) {
          this.safeEvent.list = res.result;
        }
      });
    },
    openSafeList() {
      this.fetchList_safeEvent();
      this.$refs.safeList.showBox();
    },
    openHandleLayer_safeEvent(row) {
      this.safeEvent.detailData = {
        eventLevelName: this.safeEvent.level[row.eventLevel],
        ...row
      };
      this.safeEvent.dialogShow = true;
    },
    closeHandleLayer_safeEvent() {
      this.safeEvent.dialogShow = false;
    },
    handle_safeEvent(opts) {
      aRequest
        .handleAlarm_safe_Api({
          keyGuid: opts.keyGuid,
          IsMessage: opts.isSendMsg,
          handleContent: opts.content
        })
        .then(res => {
          if (res.code == 1) {
            this.$message({
              message: res.message,
              type: "success"
            });
            this.safeEvent.dialogShow = false;
            this.fetchList_safeEvent();
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        });
    },
    // 异步更新 轨迹点 表格的 地理位置信息
    getTrackPlace(row, column, cellValue) {
      if (column.property != "position") {
        return cellValue;
      } else {
        if (!row.lon || !row.lat) {
          row.position = "经纬度不存在无法解析地理位置";
        } else {
          if (
            row.position == "加载中..." ||
            row.position == "" ||
            row.position == undefined
          ) {
            row.position = "加载中...";
            let lnglat = [row.lon, row.lat];
            this.$refs.aLogisMap.mapAPI.getAddress(lnglat, res => {
              row.position =
                res === null || res.formattedAddress == ""
                  ? "当前车辆暂无轨迹点"
                  : res.formattedAddress;
            });
          }
          return cellValue;
        }
      }
    },
    ignore_safeEvent(row) {
      this.$confirm(
        `确定要忽略 ${row.vehicleNo} 的“${row.eventTypeName}”事件吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        aRequest
          .handleAlarm_safe_Api({ keyGuid: row.keyGuid, isIgnore: 1 })
          .then(res => {
            if (res.code == 1) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.fetchList_safeEvent();
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          });
      });
    }
  },
  created() {
    // 初始化tab
    this.statTabList = JSON.parse(JSON.stringify(this.STAT_TAB_LIST));
  },
  mounted() {
    // 监控页面尺寸变更
    this.pageResize();
    window.addEventListener("resize", this.pageResize);
    this.fetchVehicleTree(-1); // 请求车辆列表数据
    this.fetchSetting(); // 获取车辆定位设置
  },
  beforeDestroy() {
    this.clearTimer_safeEvent();
  }
};
</script>
<style lang="scss" scoped>
$--font-color: #444;
.el-table {
  margin-top: 0 !important;
}

.el-table .el-table__header thead tr,
.el-table thead th {
  background-color: #e2e8f0 !important;
}

.el-table td,
.el-table th {
  padding: 5px 0 !important;
}

.el-table .cell {
  line-height: inherit !important;
}

.el-table thead,
.el-table th {
  color: $--font-color !important;
}

.el-table .caret-wrapper {
  height: 20px;
}
.rightBox {
  .top {
    display: flex;
    align-items: center;
  }
}
</style>
